// The chat bundle — react-markdown, the conversation stack, the drawer — is fetched only
// for the users the flag and the tester allowlist actually let open it. The gate has to sit
// outside the dynamic import or every user downloads the chunk to be told it is off.

import React from 'react';
import { useLocation } from 'react-router-dom';

import { useAuth } from '../../hooks/useAuth';
import { agentChatEnabled } from './chatEnabled';

const ChatDrawer = React.lazy(() => import('./ChatDrawer'));

function ChatEntry() {
  const { user } = useAuth();
  const { pathname } = useLocation();

  const enabled = agentChatEnabled({
    envFlag: import.meta.env.VITE_AGENT_CHAT_ENABLED,
    userEmail: user?.email,
    allowlistRaw: import.meta.env.VITE_ACH_TESTER_EMAILS,
    pathname,
  });
  if (!enabled) return null;

  // No fallback: the launcher appearing a moment late is better than a placeholder
  // flashing over the page.
  return (
    <React.Suspense fallback={null}>
      <ChatDrawer />
    </React.Suspense>
  );
}

export default ChatEntry;
